
export class BC {
    id_bc:number;
    motif:any;
    im:any;
    etat_agent:any;
    info_patient : any;
    nombre:any;
    validateur:any;
    dir_agent:any;
    etat_bc : any = "A";   
    date_creation: Date = new Date();
       date_validation: Date;
       //322670
       //320744
    constructor(id_bc:number){
           
    }
}
